<template>
  <a-modal
    title="设置角色"
    :maskClosable="false"
    :visible="showModal"
    :confirmLoading="confirmLoading"
    @cancel="handleCancel"
    @ok="handleOk"
    okText="提交"
  >
    <a-spin :spinning="spinning">
      <div class="set-role-content">
        <div>
          <a-checkbox
            :indeterminate="indeterminate"
            @change="onCheckAllChange"
            :checked="checkAll"
          >
            {{ checkAllTitle }}
          </a-checkbox>
        </div>
        <br />
        <a-checkbox-group
          :options="rolesList"
          v-model="checkedRoles"
          @change="checkBoxChange"
        >
        </a-checkbox-group>
      </div>
    </a-spin>
  </a-modal>
</template>

<script>
import { getRoleList, setUserRoles, getUserRoles } from '@/apis/user'

export default {
  data () {
    return {
      confirmLoading: false,
      checkedRoles: [],
      indeterminate: true,
      checkAll: false,
      rolesList: [],
      spinning: false
    }
  },
  computed: {
    checkAllTitle () {
      return this.checkAll ? '取消全选' : '全选'
    }
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    userId: {
      type: String
    }
  },
  methods: {

    checkBoxChange (checkedList) {
      this.checkedRoles = checkedList
      this.indeterminate = checkedList.length && (checkedList.length < this.rolesList.length)
    },
    onCheckAllChange (e) {
      Object.assign(this, {
        checkedRoles: e.target.checked ? this.rolesList : [],
        indeterminate: false,
        checkAll: e.target.checked
      })
    },
    handleCancel () {
      this.$emit('cancel')
    },
    handleOk (e) {
      this.confirmLoading = true
      setUserRoles({
        userId: this.userId,
        roles: this.checkedRoles.join(',')
      }).then(res => {
        if (res.data.state === 1) {
          this.$message.success('角色设置成功')
          this.$emit('submit')
        }
        this.confirmLoading = false
      })
    },
    //
    _getUserRoles () {
      this.checkedRoles = []
      this.spinning = true
      if (this.userId) {
        getUserRoles({
          userId: this.userId
        }).then(res => {
          const result = res.data.attribute
          if (result.length) {
            this.checkedRoles = result.map(item => item.name)
          }
          this.spinning = false
        })
      }
    },
    //  获取角色列表
    _getRoles () {
      getRoleList().then(res => {
        this.rolesList = res.data.attribute.map(item => item.name)
      })
    }
  },
  mounted () {
    this._getRoles()
  },
  watch: {
    userId: function (value) {
      this._getUserRoles()
    }
  }
}
</script>

<style lang="less" scoped>
.set-role-content /deep/ .ant-checkbox-group-item {
  width: 30%;
  padding: 8px 0;
}
</style>
